import { addDoubleQuotes, isNumber } from '../utils/smartutils';
import { QUESTION_TYPE } from '../utils/constants';

export function questionFindAllActivesQuery() {
  const query = `{
    questionFindAllActives{id, title, active, type, tags}
  }`;
  return query;
}

export function questionFindAllQuery() {
  const query = `{
    questionFindAll{id, title, active, type, tags}
  }`;
  return query;
}

export function questionFindByIdQuery(id) {
  const query = `{
    questionFindById( id: ${id}){id, title, description, active, type, tags, answers{id, description, correct, trueOrFalse}}
  }`;
  return query;
}

export function questionFindByTagsAndTitle(filter) {
  const query = `{
    questionFindByTagsAndTitle(filter: "${filter}") {id, title, description, answers{id, description, correct, active, trueOrFalse}}
  }`;
  return query;
}

export function removeQuestionMutation(id) {
  const mutation = `mutation {questionRemove(id: ${id})}`;
  return mutation;
}

export function questionSaveMutation(values) {
  let answers = [];
  if (values.type !== QUESTION_TYPE.DESCRIPTIVE) {
    answers = values.answers.map((item) => ({
      id: isNumber(item.id) ? item.id : 0,
      description: item.description,
      correct: item.correct,
      trueOrFalse: item.trueOrFalse ? item.trueOrFalse : '',
      deleted: false,
      active: true,
    }));
  }
  const mutation = `mutation {
    questionSave(
      question: {id: ${values.id ? values.id : 0},
      title: ${addDoubleQuotes(values.title)},
      description: ${addDoubleQuotes(values.description)},
      type: ${addDoubleQuotes(values.type.value)},
      tags: ${addDoubleQuotes(values.tags)},
      deleted: ${!!values.deleted},
      active: ${values.active},
      answers: ${JSON.stringify(answers).replace(/"([^(")"]+)":/g, '$1:')},
      }),
    {id}
  }`;
  return mutation;
}
